import UploadApi from '@/apis/upload-api';
import { Component, Prop } from 'vue-property-decorator';
import { IFile } from '@/helpers/upload';
import Base from '../Base';
import NotificationHelper from '@/helpers/notification';

@Component({})
export default class DropZone extends Base {
  $refs: {
    fileInput: HTMLInputElement;
  };
  isUploading: boolean = false;

  @Prop()
  existingFileNames: string[];

  @Prop({ required: false })
  onUploadSuccess: (arg) => {};

  get uploadText(): string {
    return this.isUploading ? 'Uploading...' : 'Upload';
  }

  openFilePicker() {
    this.$refs.fileInput.click();
  }

  async uploadFile(event) {
    this.isUploading = true;
    const formData = new FormData();
    let duplicateFileName = false;
    let containFileMoreThanMax = false;

    event.target.files.forEach((file) => {
      if (this.existingFileNames.includes(file.name)) {
        duplicateFileName = true;
      }

      // 50MB
      if (file.size > 50 * 1024 * 1024) {
        containFileMoreThanMax = true;
      }

      formData.append('files[]', file);
    });

    if (duplicateFileName) {
      NotificationHelper.error(
        'A file with same name already exists.  Please rename and try again.',
        '.drop-zone__notification-container',
      );
      this.isUploading = false;
      this.$refs.fileInput.value = '';

      return;
    }

    if (containFileMoreThanMax) {
      NotificationHelper.error('Max file size is 50MB', '.drop-zone__notification-container');
      this.isUploading = false;
      this.$refs.fileInput.value = '';

      return;
    }

    const response = await UploadApi.upload(formData);

    if (this.onUploadSuccess) this.onUploadSuccess(response.files);

    this.isUploading = false;
    this.$refs.fileInput.value = '';
  }
}
